
import StoryblokLink from "../link/StoryblokLink";
import SBEditable from "../sbEditable/sbEditable";
import styles from "./leftNavItem.module.scss";

function LeftNavItem({ lastItem, blok, selected, onSelected }) {
  return (
    <li>
      <SBEditable blok={blok} key={blok._uid} withClass={styles.root}>
        {/* todo this will get updated to use the Link component when it supports anchors */}
        <StoryblokLink
          linkObject={blok.link}
          onClick={onSelected}
          className={
            `${styles.link}` +
            (selected ? ` ${styles.selectedItem}` : "") +
            (lastItem ? ` ${styles.lastItem}` : "")
          }
        >
          <span className={styles.mobileLabel}>
            {blok.mobile_label ? blok.mobile_label : blok.label}
          </span>
          <span className={styles.label}>{blok.label}</span>
        </StoryblokLink>
      </SBEditable>
    </li>
  );
}

export default LeftNavItem;
